import '@angular/localize/init';
import './src/polyfills.ts';